import { buildModelManager } from "../builder.js";
const DefaultCohortSelection = {
  __typename: true,
  id: true,
  academicYear: true,
  autoGrantAgentAccess: true,
  calendarMode: true,
  calendarSyncEnabled: true,
  calendarSyncError: true,
  calendarSyncStatus: true,
  cohortAccessibleAgents: true,
  cohortAgentAccessEnabled: true,
  cohortDebriefAudioEnabled: true,
  cohortDocReaderEnabled: true,
  cohortEnhancedScenarioAccess: true,
  cohortHasUnlimitedScenarios: true,
  cohortScenarioGenerationLimit: true,
  cohortScenarioGeneratorAccess: true,
  cohortType: true,
  completedAt: true,
  createdAt: true,
  createdById: true,
  currentEnrollment: true,
  decommissionedById: true,
  defaultAgentAccess: true,
  defaultAgentAccessMode: true,
  defaultPermissions: true,
  description: { markdown: true, truncatedHTML: true },
  displayName: true,
  enableClinicalDocNotifications: true,
  encounterVerificationEnabled: true,
  endDate: true,
  escalationMembers: true,
  escalationSettings: true,
  fisdapCalendarUrl: true,
  graduationDate: true,
  grantScenarioAccessToInstructors: true,
  institution: true,
  instructorPermissions: true,
  isActive: true,
  isComplete: true,
  lastCalendarSyncAt: true,
  lastModifiedById: true,
  longitudinalTrendConfig: true,
  maxStudents: true,
  name: true,
  phiDetectionEnabled: true,
  requirements: true,
  roleDefinitions: true,
  scenariosUsedThisYear: true,
  semester: true,
  shiftEligibility: true,
  startDate: true,
  studentEvalViewingEnabled: true,
  unlimitedScenarios: true,
  updatedAt: true
};
const modelApiIdentifier = "cohort";
const pluralModelApiIdentifier = "cohorts";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultCohortSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultCohortSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCohortSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCohortSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCohortSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultCohortSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultCohortSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createCohort",
    operationReturnType: "CreateCohort",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { cohort: { required: false, type: "CreateCohortInput" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCohortSelection
  },
  {
    type: "action",
    operationName: "bulkCreateCohorts",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkCreateCohortsInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultCohortSelection
  },
  {
    type: "action",
    operationName: "updateCohort",
    operationReturnType: "UpdateCohort",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      cohort: { required: false, type: "UpdateCohortInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCohortSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateCohorts",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkUpdateCohortsInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultCohortSelection
  },
  {
    type: "action",
    operationName: "deleteCohort",
    operationReturnType: "DeleteCohort",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteCohorts",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertCohort",
    operationReturnType: "UpsertCohort",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      cohort: { required: false, type: "UpsertCohortInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateCohortResult": { hasReturnType: false },
      "... on UpdateCohortResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCohortSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertCohorts",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkUpsertCohortsInput!]" } },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultCohortSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "cohortGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const CohortManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultCohortSelection,
  operations
);
export {
  CohortManager,
  DefaultCohortSelection
};
//# sourceMappingURL=Cohort.js.map
